export default {
  // 中文配置
  please_sign_in_first: '请先登录',
  api_error_message: 'API错误 {{url}}: {{statusText}} ({{status}})',
  time_out: '超时',
  required_message: '{{name}}是必填的',
  max_characters_50: '最多限制50个字符。',
};
